// extracted by mini-css-extract-plugin
export default {"content":"Cell_content__od7Kp","title":"Cell_title__DwvJo","col":"Cell_col__ncJZj","footer":"Cell_footer__rfnCE"};